import gsap from 'gsap';
import EventDispatcher from '../../common/EventDispatcher';
import { Global } from '../../common/global';

export default class Score {
  constructor() {
    document
      .querySelector('#score_screen #replayBtn')
      .addEventListener('click', this.replayGame.bind(this));
    document
      .querySelector('#score_screen #leaderBtn')
      .addEventListener('click', this.showLeader.bind(this));
    document
      .querySelector('#score_screen #followBtn')
      .addEventListener('click', this.doFollow.bind(this));
  }
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    this.prizeShown = false;
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
    }
  }
  showScreen(data) {
    if (data['screenKey'] !== 'Score') return false;

    document.querySelector('#score_screen .score').innerHTML = `${
      Global.totalGoalsSaved < 10 ? '0' : ''
    }${Global.totalGoalsSaved}`;
    document.querySelector('#score_screen').classList.add('active');
    gsap.delayedCall(0.1, () => {
      document.querySelector('#score_screen').classList.add('active2');
    });
    this.animateScreen();
  }
  animateScreen() {
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#score_screen .contents .title')
        .classList.add('active');
    });
    gsap.delayedCall(0.2, () => {
      document
        .querySelector('#score_screen .contents .score')
        .classList.add('active');
    });
    gsap.delayedCall(0.3, () => {
      document
        .querySelector('#score_screen .contents .btn_container:nth-child(3)')
        .classList.add('active');
    });
    gsap.delayedCall(0.4, () => {
      document
        .querySelector('#score_screen .contents .btn_container:nth-child(4)')
        .classList.add('active');
    });
    gsap.delayedCall(0.5, () => {
      document
        .querySelector('#score_screen .contents .btn_container:nth-child(5)')
        .classList.add('active');
    });
    gsap.delayedCall(0.6, () => {
      document.querySelector('#score_screen .footer').classList.add('active');
    });
  }
  async showLeader() {
    this.hideScreen();
    Global.goBackTo = 'Score';
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'show_screen',
        data: {
          screenKey: 'LeaderBoard',
        },
      },
    });
    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: 'leaderClick',
      uniqID: Global.U_ID,
    });
  }
  async replayGame() {
    this.hideScreen();

    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'replay_game',
        data: {},
      },
    });
    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: 'replayClick',
      uniqID: Global.U_ID,
    });
  }
  doFollow() {
    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: 'followClick',
      uniqID: Global.U_ID,
    });
    location.href = 'https://www.instagram.com/carlsbergindia/';
  }
  async shareGame() {
    await navigator.share({
      title: '',
      text: '',
      url: window.location,
    });
  }
  showNextScreen() {}
  hideScreen() {
    document
      .querySelector('#score_screen .contents .title')
      .classList.remove('active');
    document
      .querySelector('#score_screen .contents .score')
      .classList.remove('active');
    document
      .querySelector('#score_screen .contents .btn_container:nth-child(3)')
      .classList.remove('active');
    document
      .querySelector('#score_screen .contents .btn_container:nth-child(4)')
      .classList.remove('active');
    document
      .querySelector('#score_screen .contents .btn_container:nth-child(5)')
      .classList.remove('active');
    document.querySelector('#score_screen .footer').classList.remove('active');

    document.querySelector('#score_screen').classList.remove('active');
  }
}
